export default function authMiddleware(to, from, next) {
    const token = localStorage.getItem('token'); // Obtén el token de sesión
    const isValidSession = isSessionValid();
    //console.log(to.meta.requiresAuth);
    // Si la ruta requiere autenticación y no hay token o la sesión no es válida
    if (to.meta.requiresAuth && (!token || !isValidSession)) {
        logout(); // Cierra la sesión automáticamente si es inválida
        next({ path: '/' }); // Redirige a la página de login
    } else {
        next(); // Continúa con la navegación
    }
}

/**
 * Configura el tiempo de expiración de la sesión.
 * @param {number} expirationMinutes - Duración de la sesión en minutos.
 */
export function setSessionTime(expirationMinutes) {
    const expirationTime = new Date().getTime() + expirationMinutes * 60 * 1000; // Tiempo actual + minutos
    localStorage.setItem('expirationTime', expirationTime);
}

/**
 * Verifica si la sesión es válida.
 * @returns {boolean} - `true` si la sesión es válida, `false` si ha expirado.
 */
export function isSessionValid() {
    const expirationTime = localStorage.getItem('expirationTime');
    //console.log(expirationTime);
    if (!expirationTime) {
        return false; // No hay tiempo de expiración
    }
    const currentTime = new Date().getTime();
    return currentTime < expirationTime; // La sesión es válida si el tiempo actual es menor
}

/**
 * Cierra la sesión del usuario eliminando los datos del almacenamiento local.
 */
export function logout() {
    localStorage.removeItem('token'); // Elimina el token de sesión
    localStorage.removeItem('expirationTime'); // Elimina el tiempo de expiración
}